export const scrollTo = (event, link, offset) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        event.preventDefault();
        const id = link.startsWith('#') ? link.substring(1) : link;
        const targetElement = document.getElementById(id);

        if (targetElement) {
            window.scrollTo({
                top: targetElement.offsetTop - offset,
                behavior: "smooth"
            });
        } else {
            console.log("Element with id", id, "not found");
        }
    } else {
        console.log("window or document is not defined");
    }
};
